import { render } from "./EchartsChart.vue?vue&type=template&id=23721006"
import script from "./EchartsChart.vue?vue&type=script&lang=js"
export * from "./EchartsChart.vue?vue&type=script&lang=js"

import "./EchartsChart.vue?vue&type=style&index=0&id=23721006&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__